import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";
import { AuthenticationService } from "../../../service/api/auth/auth.service";

@Component({
    selector: "bo-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"]
})

export class HeaderComponent implements OnInit {

    @Output("toggle") toggle = new EventEmitter<boolean>();

    constructor(
        private AuthService: AuthenticationService,
        public router: Router,
        private localStorageService: LocalStorageService
    ) { }

    isToggle: boolean = false;
    userFullName: string = "";

    ngOnInit(): void {
        this.userFullName = this.localStorageService.get<string>("userEmail");
    }

    toggleSidebar(): void {
        console.log(this.isToggle);
        if (this.isToggle === false) {
            this.isToggle = true;
            this.toggle.emit(this.isToggle);
        } else {
            this.isToggle = false;
            this.toggle.emit(this.isToggle);
        }
    }

    onindex(): void {
        this.router.navigate(["/home"]);
    }

    onLogout(): void {
        const access = this.localStorageService.get<string>("accessToken");
        // const refresh = this.localStorageService.get<string>("refreshToken");
        this.AuthService.logout(access)
            .subscribe(
                () => {
                    // clear token remove user from local storage to log user out
                    this.localStorageService.clearAll();
                    this.router.navigate(["/login"]);
                }, error => {
                    this.localStorageService.clearAll();
                    this.router.navigate(["/login"]);
                    console.log("error");
                }
            );
    }

    onLoadRoleManager(): void {
        this.router.navigate(["/rolemanager"]);
    }
}
